import { ThunkAction, Action, combineReducers } from "@reduxjs/toolkit";

import errorReportingMiddleware from "shared/middleware/errorReportingMiddleware";
import adminDocumentReducer from "shared/reducers/admin/adminCaseDocumentReducer";
import adminDocumentsReducer from "shared/reducers/admin/adminCaseDocumentsReducer";
import adminCaseReducer from "shared/reducers/admin/adminCaseReducer";
import adminCasesReducer from "shared/reducers/admin/adminCasesReducer";
import adminSlideReducer from "shared/reducers/admin/adminSlideReducer";
import adminSlidesReducer from "shared/reducers/admin/adminSlidesReducer";
import labOrderPrintLogReducer from "shared/reducers/admin/labOrderPrintLogReducer";
import labOrders from "shared/reducers/admin/labOrders";
import ai from "shared/reducers/aiReducer";
import auth from "shared/reducers/authReducer";
import caseDetail from "shared/reducers/caseDetailReducer";
import caseReport from "shared/reducers/caseReportReducer";
import cases from "shared/reducers/casesReducer";
import classificationReducer from "shared/reducers/classificationReducer";
import disclaimers from "shared/reducers/disclaimerReducer";
import documentsList from "shared/reducers/documentsListReducer";
import {
  stainsReducer,
  labStainsReducer,
  externalLabsReducer,
  externalLabStainsReducer,
  labPanelsReducer,
  antigenRetrievalMethodsReducer,
  antibodySpeciesReducer,
} from "shared/reducers/frontLoaderReducers";
import labsListReducer from "shared/reducers/labsListReducer";
import usersList from "shared/reducers/listUsersReducer";
import locationCodesReducer from "shared/reducers/locationCodesReducer";
import macroHelper from "shared/reducers/macroHelperReducer";
import slideMetaReducer from "shared/reducers/meta/slideMetaReducer";
import passwordResetConfirm from "shared/reducers/passwordResetConfirmReducer";
import passwordReset from "shared/reducers/passwordResetReducer";
import requestStatuses from "shared/reducers/requestStatusesReducer";
import siteSpecificCodesReducer from "shared/reducers/siteSpecificCodesReducer";
import slideDetail from "shared/reducers/slideDetailReducer";
import slideTiles from "shared/reducers/slideTilesReducer";
import sys from "shared/reducers/sysReducer";
import toasts from "shared/reducers/toastReducer";
import userSignatures from "shared/reducers/userSignatures";
import webSocketMessageReducer from "shared/reducers/webSocketMessageReducer";
import configurePWStore from "shared/utils/configurePWStore";

import rootSaga from "./sagas";

export const rootReducer = combineReducers({
  sys,
  ai,
  auth,
  disclaimers,
  userSignatures,
  caseDetail,
  caseReport,
  cases,
  documentsList,
  slideDetail,
  slideTiles,
  usersList,
  passwordReset,
  toasts,
  passwordResetConfirm,
  macroHelper,
  requestStatuses,
  labs: labsListReducer,
  stains: stainsReducer,
  labStains: labStainsReducer,
  externalLabs: externalLabsReducer,
  externalLabStains: externalLabStainsReducer,
  labPanels: labPanelsReducer,
  antigenRetrievalMethods: antigenRetrievalMethodsReducer,
  antibodySpecies: antibodySpeciesReducer,
  locationCodes: locationCodesReducer,
  classifications: classificationReducer,
  siteSpecificCodes: siteSpecificCodesReducer,
  webSocketMessages: webSocketMessageReducer,

  admin: combineReducers({
    cases: adminCasesReducer,
    case: adminCaseReducer,
    documents: adminDocumentsReducer,
    document: adminDocumentReducer,
    slides: adminSlidesReducer,
    slide: adminSlideReducer,
    labOrders: labOrders,
    labOrderPrintLog: labOrderPrintLogReducer,
  }),

  meta: combineReducers({
    slides: slideMetaReducer,
  }),
});

export const store = configurePWStore({
  rootReducer,
  rootSaga,
  middleware: [errorReportingMiddleware],
  ignoredStatePaths: ["slideDetail.maskBySlideId"],
});

export default store;

export type RootState = ReturnType<typeof rootReducer>;
export type ApplicationState = RootState;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
